import script from "./OnboardingList.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingList.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingList.vue?vue&type=style&index=0&id=041a77c8&lang=scss&scoped=true"
import "./OnboardingList.vue?vue&type=style&index=1&id=041a77c8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-041a77c8"]])

export default __exports__